import { isAxiosError, type AxiosError } from 'axios'

import { useConversationQuery } from 'api/conversations/queries'
import { FetchConversationResponse } from 'api/conversations/types'

const getErrorStatus = (conversationError: Error
  | AxiosError | null) => {
  if (!conversationError || !isAxiosError(conversationError)) {
    return null
  }
  if (conversationError.response?.status === 403) {
    return 'no_access' as const
  }
  if (conversationError.response?.status === 404) {
    return 'not_found' as const
  }
  return 'unknown' as const
}

export const useConversation = (conversationId: string) => {
  const {
    data: conversationData,
    error: conversationError,
    isSuccess,
    isFetching,
    isPending,
  } = useConversationQuery<FetchConversationResponse['conversation']>(
    { id: conversationId },
    {
      enabled: Boolean(conversationId),
      select: data => data.conversation,
    },
  )

  return {
    data: conversationData,
    errorStatus: getErrorStatus(conversationError),
    isFetching,
    isPending,
    isSuccess,
  }
}
